import React from "react";
import { useSelector } from "react-redux";
import styles from "./api-result.module.css";
import { getPortal } from "../../services/selectors";


const ApiResult = () => {

  const { title, text } = useSelector(getPortal);


  return (
    <>
      <h2 className={styles.title}>
        {title}
      </h2>
      <p className={styles.text}>
        {text}
      </p>
      {/* {text[0].length !== 0 && text[0].map((item, index) => {
        return (
          <p key={index} className={styles.text}>
            {item}
          </p>)
      })} */}

    </>
  )
}

export default ApiResult;
